<template>
  <div style="padding: 15px">
    <b-row>
      <b-col>
        <div style="display: inline-block">
          <b-breadcrumb>
            <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
            <b-breadcrumb-item>
              <router-link tag="a" to="/audit-agree">Audit</router-link>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>{{ formName }}</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
        <!-- Logout Icon -->
        <b-button
          style="
            display: inline-block;
            position: absolute;
            top: -5px;
            right: 15px;
            width: 30px;
          "
          size="lg"
          @click="logout()"
          variant="outline-danger"
          class="p-1"
        >
          <i class="fa fa-power-off"></i>
        </b-button>
      </b-col>
    </b-row>
    <h5 class="auth-logo">
      <div style="text-decoration: underline">Audit List</div>
    </h5>
    <b-button
      size="sm"
      variant="primary"
      class="ml-2"
      style="margin-top: -40px"
      @click="LoadData()"
    >
      Refresh
    </b-button>
    <b-form-input
  v-model="search"
  placeholder="Search..."
  style="margin-bottom: 10px; font-size: 14px"
></b-form-input>
    <b-container fluid style="padding-left: 5px; padding-right: 5px">
      <b-row align-h="start">
        <b-col sm="12">
          <b-row class="dynamic-font-head" style="margin: 0px; font-weight: 600">
            <div style="display: contents; font-weight: 600">
              <span style="width: 5%; padding-bottom: 10px">
                <center>Act</center>
              </span>
              <span style="width: 25%; padding-bottom: 10px"
                ><center>Store</center></span
              >
              <span style="width: 20%; padding-bottom: 10px"
                ><center>Brand</center></span
              >
              <span style="width: 10%; padding-bottom: 10px">
                <center>Article</center>
              </span>
              <span style="width: 15%; padding-bottom: 10px">
                <center>Pic</center>
              </span>
              <span style="width: 10%; padding-bottom: 10px">
                <center>Status</center>
              </span>
              <span style="width: 15%; padding-bottom: 10px">
                <center>File</center>
              </span>
            </div>
          </b-row>
          <b-row
            v-for="row in filteredList"
            :key="row.id"
            class="dynamic-font"
            style="margin: 0px; margin-bottom:15px; font-weight: 500;"
          >
            <div style="display: contents">
              <span style="width: 5%; padding-bottom: 10px">
                <center>
                  <b-icon
                    v-if="row.category != 'validasi'"
                    @click="confirmSubmit(row)"
                    scale="2"
                    icon="file-earmark-check-fill"
                    style="cursor: pointer"
                    title="view"
                  ></b-icon>
                  <b-icon
                    v-if="row.category == 'validasi'"
                    @click="confirmSubmit2(row)"
                    scale="2"
                    icon="file-earmark-check"
                    style="cursor: pointer;"
                    title="view"
                  ></b-icon>
                </center>
              </span>
              <span style="width: 25%; padding-bottom: 10px"
                ><center>{{ row.store }}</center></span
              >
              <span style="width: 20%; padding-bottom: 10px">
                <center>{{ row.brand }}</center>
              </span>
              <span style="width: 10%; padding-bottom: 10px">
                <center>{{ row.qty }}</center>
              </span>
              <span style="width: 15%; padding-bottom: 10px">
                <center>{{ row.nik_assign }}</center>
              </span>
              <span style="width: 10%; padding-bottom: 10px">
                <center>{{ row.status_audit }}</center>
              </span>
              <span
                style="width: 15%; padding-bottom: 10px; text-align: center"
              >
                <b-icon
                  v-if="row.category != 'validasi'"
                  @click="downloadListBaPDF(row)"
                  style="cursor: pointer"
                  scale="2"
                  icon="file-pdf-fill"
                  title="download"
                ></b-icon>
                <b-icon
                  v-if="row.category == 'validasi'"
                  @click="downloadListBaExcPDF(row)"
                  style="cursor: pointer;"
                  scale="2"
                  icon="file-pdf"
                  title="download"
                ></b-icon>
                <!-- <b-icon
                  v-if="row.status_audit === 'Done'"
                  @click="downloadPDF(row)"
                  style="position: relative; left: 10px; cursor: pointer"
                  scale="2"
                  icon="file-pdf-fill"
                  title="download"
                ></b-icon> -->
              </span>
            </div>
          </b-row>
        </b-col>
      </b-row>

      <!-- <b-row style="padding-left: 10px; padding-right: 10px">
        <b-col sm="12" class="text-right">
          <b-button variant="primary" @click="addNewAudit"> Mulai </b-button>
        </b-col>
      </b-row> -->

      <Loader
        v-if="isLoadingData"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
      <!-- <PrintBa />
      <PrintList /> -->
      <PrintBaList />
      <PrintBaExcList />
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Loader/Loader";
import { APIPATH_CGC } from "../../../../api/api-paths";
import { fnPOST } from "../../../../api/api-methods";
// import PrintBa from "./ba-pdf.vue";
// import PrintList from "./list-pdf.vue";
import PrintBaList from "./ba-list-pdf.vue";
import PrintBaExcList from "./ba-list-exc-pdf.vue";
import { EventBus } from "./eventBus";
export default {
  components: {
    Loader,
    // PrintBa,
    // PrintList,
    PrintBaList,
    PrintBaExcList,
  },
  data() {
    return {
      isLoadingData: false,
      formName: "Audit-List",
      isLoading: false,
      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
      tokoName: null,
      tokoId: null,
      spgNik: null,
      spgName: null,
      dataList: [],
      search: ""
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    filteredList() {
    if (!this.search) {
      return this.dataList;
    }

    const s = this.search.toLowerCase();

    return this.dataList.filter(row =>
      String(row.store).toLowerCase().includes(s) ||
      String(row.brand).toLowerCase().includes(s) ||
      String(row.qty).toLowerCase().includes(s) ||
      String(row.nik_assign).toLowerCase().includes(s) ||
      String(row.status_audit).toLowerCase().includes(s)
    );
  }
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    setData() {
      let data = this.$route.params.data;
      if (data) {
        this.tokoId = data.store_code;
        this.tokoName = data.store;
        this.spgNik = data.nik;
        this.spgName = data.name;
        this.LoadData();
      } else {
        data = JSON.parse(localStorage.getItem("spg_audit"));
        if (data) {
          this.tokoId = data.store_code;
          this.tokoName = data.store;
          this.spgNik = data.nik;
          this.spgName = data.name;
          this.LoadData();
        } else {
          this.$router.push({ name: "CGCAudit" });
        }
      }
      console.log(data);
      console.log(this.tokoName);
    },

    // downloadPDF(row) {
    //   const param = row.id;
    //   EventBus.$emit("open-print-ba", param);
    // },
    // downloadListPDF(row) {
    //   const param = row.id;
    //   EventBus.$emit("open-print-list", param);
    // },
    downloadListBaPDF(row) {
      const param = row.id;
      EventBus.$emit("open-print-ba-list", param);
    },
    downloadListBaExcPDF(row) {
      const param = row.id;
      EventBus.$emit("open-print-ba-exc-list", param);
    },

    LoadData() {
      this.isLoadingData = true;
      fnPOST(APIPATH_CGC.getListAudit, {
        store_code: this.tokoId,
        nik: this.spgNik,
      })
        .then((response) => {
          this.isLoadingData = false;
          this.dataList = response.data.payload;
        })
        .catch((error) => {
          this.isLoadingData = false;
          this.showNotification({
            message: error,
            type: "error",
          });
        });
    },

    logout() {
      localStorage.removeItem("spg_audit");
      this.$router.push({ name: "CGCAudit" });
    },

    confirmSubmit(data) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure want check article " + data.brand + " ? ",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = String(value);
          if (this.boxTwo == "true") {
            this.viewDetailAudit(data);
          } else {
            // no
          }
        }).catch;
    },
    confirmSubmit2(data) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure want check article " + data.brand + " ? ",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = String(value);
          if (this.boxTwo == "true") {
            this.viewDetailAudit2(data);
          } else {
            // no
          }
        }).catch;
    },

    viewDetailAudit(data) {
      if (this.spgNik.includes("@")) {
        this.$router.push({
          name: "CGCAuditForm",
          params: { data: data },
        });
      } else {
        console.log(data);
        if (data.nik_assign == null) {
          this.$router.push({
            name: "CGCAuditForm",
            params: { data: data },
          });
        } else {
          if (data.nik_assign !== this.spgNik) {
            this.showNotification({
              type: "error",
              message: "You are not authorized to view this audit",
            });
            return;
          } else {
            this.$router.push({
              name: "CGCAuditForm",
              params: { data: data },
            });
          }
        }
      }
    },
    viewDetailAudit2(data) {
      if (this.spgNik.includes("@")) {
        this.$router.push({
          name: "CGCAuditFormExc",
          params: { data: data },
        });
      } else {
        console.log(data);
        if (data.nik_assign == null) {
          this.$router.push({
            name: "CGCAuditFormExc",
            params: { data: data },
          });
        } else {
          if (data.nik_assign !== this.spgNik) {
            this.showNotification({
              type: "error",
              message: "You are not authorized to view this audit",
            });
            return;
          } else {
            this.$router.push({
              name: "CGCAuditFormExc",
              params: { data: data },
            });
          }
        }
      }
    },
  },
  created() {
    this.setData();
  },
};
</script>
<style src="../CGC.scss" lang="scss" scoped />
